const PROJECT_FLAVOURS_MAP = {
  projects: 'Project{s}',
  work_orders: 'Work order{s}',
  both: 'Project{s} / Work order{s}',
};
const TASK_FLAVOURS_MAP = {
  projects: 'To-do{s}',
  work_orders: 'Job{s}',
  both: 'To-do{s} / Job{s}',
};
const pluralRegex = /\{(s)\}/gi;

/**
 * Filter that given the flavour of projects that an organization has, returns the
 * correct label for the project/work order, with an optional pluralization argument.
 *
 * @param {String} flavour the kind of flavour that the organization has for projects; one of:
 *                         'projects', 'work_orders' or 'both'.
 * @param {Boolean} plural whether or not the label should be pluralized.
 * @returns String
 */
export function getProjectFlavourLabel(flavour, plural = false, manualTimeRequest = false) {
  const label = manualTimeRequest
    ? PROJECT_FLAVOURS_MAP.projects
    : PROJECT_FLAVOURS_MAP[flavour] || PROJECT_FLAVOURS_MAP.projects;

  return label.replace(pluralRegex, plural ? '$1' : '');
}

/**
 * Filter that given the flavour of projects that an organization has, returns the
 * correct label for the to-do/job, with an optional pluralization argument.
 *
 * @param {String} flavour the kind of flavour that the organization has for projects; one of:
 *                         'projects', 'work_orders' or 'both'.
 * @param {Boolean} plural whether or not the label should be pluralized
 * @returns String
 */
export function getTaskFlavourLabel(flavour, plural = false, manualTimeRequest = false) {
  const label = manualTimeRequest
    ? TASK_FLAVOURS_MAP.projects
    : TASK_FLAVOURS_MAP[flavour] || TASK_FLAVOURS_MAP.projects;

  return label.replace(pluralRegex, plural ? '$1' : '');
}
